import { Modal, Collapse } from "bootstrap";
import "./jquery.inview.min";
import "./main";
import "./navigation";
import "select2/dist/css/select2.css";
import "../less/ui-components/bootstrap/modal.scss";

import setContactModalHandlers from "./modals/setContactModalHandlers";
import "../less/ui-components/bootstrap/modal-progress";

(function () {
  let arr = [];
  $('button[data-bs-toggle="modal"]').each(function () {
    arr.push($(this).data("bs-target"));
  });
  [...new Set(arr)].forEach((element) => setContactModalHandlers(element));

  setContactModalHandlers("#modalContactUsABTest");
})();

$(".owl-carousel").each(function () {
  var $this = $(this);
  $this.one("inview", function () {
    jQuery(".owl-carousel").trigger("refresh.owl.carousel");

    $this.find(".owl-item.cloned img").each(function () {
      var getSrcAttr = $(this).attr("data-src");
      $(this).attr("src", getSrcAttr).removeClass("lazy");
    });
  });
});

jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault"),
    });
  },
};
jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("wheel", handle, { passive: true });
  },
};
jQuery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("mousewheel", handle, { passive: true });
  },
};

// Init canvas snow start

(function () {
  var requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
  window.requestAnimationFrame = requestAnimationFrame;
})();

(function () {
  var canvas = document.getElementById("canvas-snow");
  if (canvas == null) {
    return;
  }

  var flakes = [],
    ctx = canvas.getContext("2d"),
    flakeCount = 120,
    mX = -100,
    mY = -100,
    antiGravity = 0.2;

  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight + 5;

  if (window.innerWidth < 768) {
    flakeCount = 30;
  } else if (window.innerWidth >= 768 && window.innerWidth <= 992) {
    flakeCount = 60;
  }

  function snow() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (var i = 0; i < flakeCount; i++) {
      var flake = flakes[i];

      if (flake.delay > 0) {
        flake.delay--;
      } else {
        var x = flake.x,
          y = flake.y,
          minDist = 150,
          x2 = mX,
          y2 = mY;

        var dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y)),
          dx = x2 - x,
          dy = y2 - y;

        if (dist < minDist) {
          var force = (1 - dist / minDist) * antiGravity;
          flake.velX += (force * (x - x2)) / dist;
          flake.velY += (force * (y - y2)) / dist;
        } else {
          flake.velX *= 0.98;
          if (flake.velY <= flake.speed) {
            flake.velY = flake.speed;
          }
          flake.velX += Math.cos((flake.step += 0.05)) * flake.stepSize;
        }

        ctx.fillStyle = "rgba(255,255,255," + flake.opacity + ")";
        flake.y += flake.velY;
        flake.x += flake.velX;

        if (flake.y >= canvas.height || flake.y <= 0) {
          reset(flake);
        }

        if (flake.x >= canvas.width || flake.x <= 0) {
          reset(flake);
        }

        ctx.beginPath();
        ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }
    requestAnimationFrame(snow);
  }

  function reset(flake) {
    flake.x = Math.floor(Math.random() * canvas.width);
    flake.y = 0;
    flake.size = Math.random() * 2 + 2;
    flake.speed = Math.random() * 0.5 + 0.5;
    flake.velY = flake.speed;
    flake.velX = 0;
    flake.opacity = Math.random() * 0.1 + 0.2;
    flake.delay = Math.floor(Math.random() * 700);
  }

  function init() {
    for (var i = 0; i < flakeCount; i++) {
      var x = Math.floor(Math.random() * canvas.width),
        y = Math.floor(Math.random() * -canvas.height),
        size = Math.random() * 2 + 2,
        speed = Math.random() * 0.5 + 0.5,
        opacity = Math.random() * 0.1 + 0.2,
        delay = Math.floor(Math.random() * 700);

      flakes.push({
        speed: speed,
        velY: speed,
        velX: 0,
        x: x,
        y: y,
        size: size,
        stepSize: Math.random() / 30,
        step: 0,
        opacity: opacity,
        delay: delay,
      });
    }

    snow();
  }

  window.addEventListener("mousemove", function (e) {
    (mX = e.clientX), (mY = e.clientY);
  });

  window.addEventListener("resize", function () {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight + 5;

    if (window.innerWidth < 768) {
      flakeCount = 30;
    } else if (window.innerWidth >= 768 && window.innerWidth <= 992) {
      flakeCount = 60;
    } else {
      flakeCount = 120;
    }
  });

  init();
})();

// Init canvas snow end
